import { _ } from '@splunk/ui-utils/i18n';
import { type PresetHOC } from '../types/PresetHOC';

type TokenSetterType = 'dynamic' | 'static';

/**
 * Add a property to the Item class to inform that it can set tokens based on item events
 * @param {LayoutItem} Item The item to enhance
 */
export const withSetTokens: PresetHOC<
    {
        canSetTokens?: TokenSetterType[];
        interactionsFilterMetadata?: string[];
    },
    TokenSetterType[]
> = (Item, type = ['dynamic', 'static']) => {
    Item.canSetTokens = type;
    Item.interactionsFilterMetadata ??= [];
    Item.interactionsFilterMetadata.push(_('Set tokens'));

    return Item;
};
